import {deserializeAs} from 'cerialize';

export class Pitd {
  @deserializeAs('identifiant_pitd')
  identifiantPid: string;

  @deserializeAs('libelle_pitd')
  libellePitd: string;
}
